import axios from "axios";
import { router } from "./router";
import AuthService from "./services/auth.service";
axios.interceptors.response.use(
  res => res,
  err => {
    const r = err.response;

    // Requests batched with Promise.allSettled (e.g. attachment uploads)
    // must always settle — a permission/session error on one of them can't
    // be allowed to hang the whole batch forever. Those calls opt out of
    // the redirect-and-never-resolve behaviour via `settleAuthErrors`.
    const settleAuthErrors = err.config && err.config.settleAuthErrors;

    if (r && r.status === 401) {
      AuthService.logout();
      if (settleAuthErrors) {
        return Promise.reject(err);
      }
      return new Promise(() => {});
    }
    if (r && r.status === 403) {
      if (settleAuthErrors) {
        return Promise.reject(err);
      }
      router.push("/forbidden").catch(() => {});
      return new Promise(() => {});
    }
    if (r && r.status === 419 && r.data && r.data.two_factor_required) {
      // The router guard may be redirecting to /2fa for this same 419;
      // whichever navigation loses the race must not reject unhandled.
      router.push("/2fa").catch(() => {});
    }

    return Promise.reject(err);
  }
);
export default axios;
